import { createFileRoute, Outlet } from '@tanstack/react-router';

import { i18n } from '../../i18n';

// Settings › Columns: Structured Columns, Custom Columns and Materials (ENG-1035).
export const Route = createFileRoute('/columns')({
  staticData: {
    permissionSection: 'settings',
    section: 'Settings',
    breadcrumb: () => i18n.t('terms.columns', { ns: 'common' }),
  },
  component: Outlet,
});
